.split-pane :global(.Pane.vertical.Pane2) {
    height: 100%;
}
